import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const ROUTE_PATHS = {
  HOME: '/',
  ABOUT: '/o-mnie',
  SERVICES: '/uslugi',
  SERVICES_INDIVIDUAL: '/uslugi-indywidualne',
  SERVICES_BUSINESS: '/uslugi-dla-firm',
  REVIEWS: '/opinie',
  GALLERY: '/galeria',
  PUBLICATIONS: '/publikacje-i-media',
  CONTACT: '/kontakt',
} as const;

export type ServiceCategory = 'psychologia' | 'seksuologia' | 'mediacje' | 'biznes' | 'szkolenia';

export interface Service {
  id: string;
  title: string;
  shortDescription: string;
  fullDescription: string;
  category: ServiceCategory;
  iconName: string;
  benefits: string[];
  businessImpact?: string[];
  targetAudience: string;
}

export interface Qualification {
  id: string;
  year: string;
  title: string;
  institution: string;
  description?: string;
  category: 'academic' | 'professional' | 'certification';
}

export interface Publication {
  id: string;
  title: string;
  year: string;
  type: 'ksiazka' | 'artykul' | 'konferencja' | 'media';
  publisher?: string;
  description: string;
  url?: string;
}

export interface PracticeArea {
  title: string;
  description: string;
  iconName: string;
}

export const springPresets = {
  snappy: {
    type: "spring",
    stiffness: 400,
    damping: 30,
  },
  gentle: {
    type: "spring",
    stiffness: 300,
    damping: 35,
  },
  bouncy: {
    type: "spring",
    stiffness: 500,
    damping: 25,
  },
  smooth: {
    type: "spring",
    stiffness: 200,
    damping: 40,
  },
} as const;

export const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: springPresets.gentle,
  },
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const hoverLift = {
  rest: { scale: 1 },
  hover: {
    scale: 1.02,
    y: -4,
    transition: springPresets.snappy,
  },
};